import { Component, EventEmitter, signal, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminClient, CheckMergeConflictsCommand, MergeDuplicateEducatorsCommand } from '../services/api.service';
import { catchValidationErrors } from '../utilities/validator-utilities';
import { finalize } from 'rxjs';

@Component({
  selector: 'cert-merge-confirmation-modal',
  templateUrl: './merge-confirmation-modal.component.html',
  styles: ``,
  standalone: false,
})
export class MergeConfirmationModalComponent implements OnInit {
  primaryEIN!: string;
  primaryPersonId!: number;
  duplicateEIN!: string;
  duplicatePersonId!: number;
  confirmationInput!: string;
  mergeConflictsExist = true;
  dataLoaded = signal(false);
  mergeInProgress = signal(false);

  errorEmitter = new EventEmitter<any>();

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly adminClient: AdminClient,
  ) {}

  ngOnInit() {
    this.getPotentialMergeConflicts();
  }

  getPotentialMergeConflicts() {
    const command: CheckMergeConflictsCommand = {
      primaryPersonId: this.primaryPersonId,
      duplicatePersonId: this.duplicatePersonId,
    };
    this.adminClient
      .checkMergeConflicts(command)
      .pipe(
        catchValidationErrors(undefined, this.errorEmitter),
        finalize(() => this.dataLoaded.set(true)),
      )
      .subscribe((x) => {
        // If the command returns successfully, then no conflicts were found.
        this.mergeConflictsExist = false;
      });
  }

  onConfirm(confirmed: boolean): void {
    if (confirmed) {
      const command: MergeDuplicateEducatorsCommand = {
        primaryPersonId: this.primaryPersonId,
        duplicatePersonId: this.duplicatePersonId,
      };

      this.mergeInProgress.set(true);
      this.adminClient
        .mergeDuplicateEducators(command)
        .pipe(
          catchValidationErrors(undefined, this.errorEmitter),
          finalize(() => this.mergeInProgress.set(false)),
        )
        .subscribe((x) => {
          this.activeModal.close(confirmed);
        });
    } else {
      this.activeModal.close();
    }
  }

  confirmationInputEnteredIncorrectly(): boolean {
    return !this.confirmationInput || this.confirmationInput.toLowerCase() !== 'merge';
  }
}
